module.exports = __webpack_public_path__ + "img/logo2.0cac1adb.png";